// vendor styles
// import '../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.css'
// import '../node_modules/bootstrap3/dist/css/bootstrap.min.css'
// import '../node_modules/mmenu-js/dist/mmenu.css'
// import '../node_modules/slick-carousel/slick/slick.css'
// import '../node_modules/ion-rangeslider/css/ion.rangeSlider.min.css'
//import '../node_modules/vue-slider-component/theme/antd.css';

//import $ from "jquery";
import Vue from 'vue';

import { register } from 'swiper/element/bundle';
import 'swiper/swiper-bundle.css';
import axios from 'axios';
import VModal from 'vue-js-modal';

Vue.use(VModal, {
    dynamicDefault: {
      opened: function(){

        console.log("open");
      }
    }
});
//require('slick-carousel');
// import $ from "jquery.2";
// //window.$ = window.jQuery = $;
// import 'slick-carousel'
// import 'popper.js'
// import 'bootstrap3'
// import '@fancyapps/fancybox'
// import 'mmenu-js'
// import 'jquery.rateit'
// import 'vanilla-lazyload'
// import 'ion-rangeslider'
// import 'inputmask'

// import FileUpload from 'vue-upload-component';
window.Vue = Vue;
window.axios = axios;
register();
// import axios from 'axios';
// window.axios = axios;


// import VueSlider from 'vue-slider-component';
// window.VueSlider = VueSlider;



//import inputmask from '../node_modules/inputmask/dist/jquery.inputmask.js'


//import * as jquery from 'jquery';

// window.$ = $;
// window.jQuery = jQuery;
// vendor js


//import "../../templates/vostok/bootstrap/js/bootstrap.min.js"
// import "../../templates/vostok/js/fancybox-master/dist/jquery.fancybox.min.js"
// import "../../templates/vostok/js/mmenu-js-master/dist/mmenu.js"
// import "../../templates/vostok/js/rateit/jquery.rateit.min.js"
// import "../../templates/vostok/js/lazyload.min.js"
// import "../../templates/vostok/js/ion.rangeSlider/js/ion.rangeSlider.min.js"
// import "../../templates/vostok/js/slick/slick/slick.js"
// import "../../templates/vostok/js/inputmask/jquery.inputmask.bundle.js"



// set uikit in global variable
// import UIkit from 'uikit'
// window.UIkit = UIkit;



// // icons
// import Icons from '../node_modules/uikit/dist/js/uikit-icons';
// UIkit.use(Icons);
